import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GetenvironmentService {

  public EnvironmentValues = {};

  currentEnvironment = 'Prod'//Local, Stage, Test,Prod;//CHANGE ALSO IN data-sharing.service.ts

  buildPlatform = 'Web';// The values can be Web or Mobile

  envDetails = {
    Local: {
      // apiUrl: 'https://video-recording-app3026.loca.lt'
      apiUrl: 'http://localhost:3026'
      // apiUrl : 'http://192.168.43.91:3004'
    },
    Stage: {
      // apiUrl: 'http://agoranodeapp.azurewebsites.net'
      apiUrl: 'https://v.atom361.co.in'
    },
    Test: {
      apiUrl: 'http://agoranodeapp.azurewebsites.net'
    },
    Prod: {
      // apiUrl: 'https://vcpvnodeapp.azurewebsites.net'
      apiUrl: 'https://v.atom361.co.in'
    }

  }
  constructor(){}

  // Get the environment object of the current environment

  getEnvironmentDetails() {

    return this.envDetails[this.currentEnvironment];

  }

  // Get the desired property value of the current environment
  getEnvPropValue(propName) {

    return this.envDetails[this.currentEnvironment][propName];
  }

  // Get the build platform currently set

  getBuildPlatform() {

    return this.buildPlatform;
  }
}
